import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { MetricByCategoryListDirective } from '../metric-by-category-list/metric-by-category-list.directive';
import { GetCategoryScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-scroll-id.pipe';
import { GetCategoryTopScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-top-scroll-id.pipe';
import { GetMetricScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-metric-scroll-id.pipe';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-scroll-id.pipe";
import * as i2 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-top-scroll-id.pipe";
import * as i3 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-metric-scroll-id.pipe";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../metric-info-modal/metric-info-modal.component";
import * as i7 from "../../pipes/get-category-scroll-id.pipe";
import * as i8 from "../../pipes/get-category-top-scroll-id.pipe";
import * as i9 from "../../pipes/get-metric-scroll-id.pipe";
import * as i10 from "../../pipes/is-item-selected.pipe";
import * as i11 from "CalculationsApp/ts/features/metric-selector-modal/pipes/is-section-item-selected.pipe";
import * as i12 from "../../pipes/is-submenu-item-selected.pipe";
const _c0 = a0 => ({ selected: a0 });
const _c1 = a0 => ({ open: a0 });
const _c2 = (a0, a1, a2, a3) => [a0, a1, a2, a3, undefined];
const _c3 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4];
function SingleMetricByCategoryListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵpipe(2, "getCategoryScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_6_Template_div_click_1_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectCategory(category_r2)); });
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, category_r2.category_label === (ctx_r2.categorySelected == null ? null : ctx_r2.categorySelected.category_label)));
    i0.ɵɵadvance();
    i0.ɵɵattribute("category-scroll-id", i0.ɵɵpipeBind2(2, 3, ctx_r2.metricByCategoryListId, category_r2.category_label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.numSelectedPerCategoryMap[category_r2.category_label] ? category_r2.category_label + " (" + ctx_r2.numSelectedPerCategoryMap[category_r2.category_label] + ")" : category_r2.category_label);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_div_4_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.openMetricInfoModal(item_r7, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵpipe(1, "getMetricScrollId");
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_Template_div_click_2_listener() { const item_r7 = i0.ɵɵrestoreView(_r6).$implicit; const section_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectMetric(item_r7, ctx_r2.categorySelected.category_label, section_r5.section_label)); });
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵtemplate(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_div_4_Template, 2, 1, "div", 28)(5, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_div_5_Template, 3, 1, "div", 21);
    i0.ɵɵpipe(6, "isItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const section_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("metric-scroll-id", i0.ɵɵpipeBind4(1, 4, ctx_r2.metricByCategoryListId, item_r7.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", item_r7.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showInfoPopover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(6, 9, i0.ɵɵpureFunction4(15, _c2, ctx_r2.selectedMetricsMap, item_r7.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label)));
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "div", 13);
    i0.ɵɵpipe(3, "getCategoryTopScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r4); const section_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleSection(section_r5.section_label)); });
    i0.ɵɵelement(4, "div", 19);
    i0.ɵɵelementStart(5, "span", 20);
    i0.ɵɵelement(6, "strong", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_7_Template, 3, 1, "div", 21);
    i0.ɵɵpipe(8, "isSectionItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 22);
    i0.ɵɵtemplate(10, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_div_10_Template, 8, 20, "div", 23);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const section_r5 = ctx_r8.$implicit;
    const isFirstSection_r10 = ctx_r8.first;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, ctx_r2.sectionIsOpenMap == null ? null : ctx_r2.sectionIsOpenMap[section_r5.section_label]));
    i0.ɵɵadvance();
    i0.ɵɵattribute("category-top-scroll-id", isFirstSection_r10 && !section_r5.section_label ? i0.ɵɵpipeBind2(3, 5, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("textContent", section_r5.section_label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(8, 8, ctx_r2.selectedMetricsMap, ctx_r2.categorySelected.category_label, section_r5.section_label));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", section_r5.items);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵpipe(2, "getCategoryTopScrollId");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    const section_r5 = ctx_r8.$implicit;
    const isFirstSection_r10 = ctx_r8.first;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", section_r5.section_label);
    i0.ɵɵattribute("category-top-scroll-id", isFirstSection_r10 ? i0.ɵɵpipeBind2(2, 2, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_6_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r13); const item_r12 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.openMetricInfoModal(item_r12.periods[0], $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵpipe(1, "getMetricScrollId");
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_13_Template_div_click_2_listener() { const period_r15 = i0.ɵɵrestoreView(_r14).$implicit; const item_r12 = i0.ɵɵnextContext(2).$implicit; const section_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectMetric(period_r15, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r12.menu_label)); });
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵtemplate(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_13_div_4_Template, 3, 1, "div", 21);
    i0.ɵɵpipe(5, "isItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const period_r15 = ctx.$implicit;
    const item_r12 = i0.ɵɵnextContext(2).$implicit;
    const section_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("metric-scroll-id", i0.ɵɵpipeBindV(1, 3, i0.ɵɵpureFunction5(15, _c3, ctx_r2.metricByCategoryListId, period_r15.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r12.menu_label)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", period_r15.period_label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(5, 9, i0.ɵɵpureFunction5(21, _c3, ctx_r2.selectedMetricsMap, period_r15.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r12.menu_label)));
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 13);
    i0.ɵɵpipe(2, "getCategoryTopScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r11); const item_r12 = i0.ɵɵnextContext().$implicit; const section_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleSubmenu(section_r5.section_label, item_r12.menu_label)); });
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementStart(4, "span", 20);
    i0.ɵɵelement(5, "span", 14);
    i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_6_Template, 2, 1, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_7_Template, 3, 1, "div", 21);
    i0.ɵɵpipe(8, "isSubmenuItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 22)(10, "div", 32)(11, "div", 33);
    i0.ɵɵtext(12, " Select a Periodicity ");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_div_13_Template, 7, 27, "div", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    const item_r12 = ctx_r15.$implicit;
    const isFirstSectionItem_r17 = ctx_r15.first;
    const section_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1, ctx_r2.submenuIsOpenMap == null ? null : ctx_r2.submenuIsOpenMap[section_r5.section_label] == null ? null : ctx_r2.submenuIsOpenMap[section_r5.section_label][item_r12.menu_label]));
    i0.ɵɵadvance();
    i0.ɵɵattribute("category-top-scroll-id", isFirstSectionItem_r17 && !section_r5.section_label ? i0.ɵɵpipeBind2(2, 6, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("textContent", item_r12.menu_label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showInfoPopover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind4(8, 9, ctx_r2.selectedMetricsMap, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r12.menu_label));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", item_r12.periods);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r19); const item_r12 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.openMetricInfoModal(item_r12, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵpipe(1, "getMetricScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r18); const item_r12 = i0.ɵɵnextContext().$implicit; const section_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectMetric(item_r12, ctx_r2.categorySelected.category_label, section_r5.section_label)); });
    i0.ɵɵelementStart(2, "span", 34);
    i0.ɵɵpipe(3, "getCategoryTopScrollId");
    i0.ɵɵelement(4, "span", 14);
    i0.ɵɵtemplate(5, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_div_5_Template, 2, 1, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_div_6_Template, 3, 1, "div", 21);
    i0.ɵɵpipe(7, "isItemSelected");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    const item_r12 = ctx_r15.$implicit;
    const isFirstSectionItem_r17 = ctx_r15.first;
    const section_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("metric-scroll-id", i0.ɵɵpipeBind4(1, 5, ctx_r2.metricByCategoryListId, item_r12.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("category-top-scroll-id", isFirstSectionItem_r17 && !section_r5.section_label ? i0.ɵɵpipeBind2(3, 10, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", item_r12.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showInfoPopover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(7, 13, i0.ɵɵpureFunction4(19, _c2, ctx_r2.selectedMetricsMap, item_r12.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label)));
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_div_1_Template, 3, 5, "div", 30);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtemplate(3, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_container_3_Template, 1, 0, "ng-container", 16)(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_4_Template, 14, 16, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_ng_template_6_Template, 8, 24, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const isFirstSectionItem_r17 = ctx.first;
    const dropdownBlock_r20 = i0.ɵɵreference(5);
    const itemBlock_r21 = i0.ɵɵreference(7);
    const section_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", isFirstSectionItem_r17 && section_r5.section_label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.useDropdownBlock(item_r12))("ngIfThen", dropdownBlock_r20)("ngIfElse", itemBlock_r21);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_ng_container_0_Template, 8, 4, "ng-container", 15);
} if (rf & 2) {
    const section_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngForOf", section_r5.items);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 16)(2, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_2_Template, 11, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const collapsableSections_r22 = i0.ɵɵreference(3);
    const nonCollapsableSections_r23 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.useCollapsableList(ctx_r2.categorySelected))("ngIfThen", collapsableSections_r22)("ngIfElse", nonCollapsableSections_r23);
} }
function SingleMetricByCategoryListComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_Template, 6, 3, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.categorySelected.sections);
} }
/**
 * Single Metric By Category List
 *
 * Outputs:
 *   submitMetricHandler: An event emitter that emits a selected metric.
 *
 */
export class SingleMetricByCategoryListComponent extends MetricByCategoryListDirective {
    constructor(changeDetector, getCategoryScrollId, getCategoryTopScrollId, getMetricScrollId) {
        super(getCategoryScrollId, getCategoryTopScrollId, getMetricScrollId);
        this.changeDetector = changeDetector;
        this.getCategoryScrollId = getCategoryScrollId;
        this.getCategoryTopScrollId = getCategoryTopScrollId;
        this.getMetricScrollId = getMetricScrollId;
        this.submitMetricHandler = new EventEmitter();
    }
    // eslint-disable-next-line unused-imports/no-unused-vars-ts
    selectMetric(metric, ..._) {
        // Notify the metric modal of the selected metric
        this.submitMetricHandler.emit(metric);
    }
    // Reset maps
    // Add check mark for and scroll to preselected metric
    reset() {
        super.reset();
        if (this.selectedMetricName && this.selectedMetricName in this.flatMetricsMap) {
            const metricInfo = this.getMetricInfo(this.selectedMetricName);
            this.addSelectedMetricToMaps(metricInfo);
            this.scrollToMetric(metricInfo);
        }
        this.changeDetector.markForCheck();
    }
}
SingleMetricByCategoryListComponent.ɵfac = function SingleMetricByCategoryListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SingleMetricByCategoryListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.GetCategoryScrollIdPipe), i0.ɵɵdirectiveInject(i2.GetCategoryTopScrollIdPipe), i0.ɵɵdirectiveInject(i3.GetMetricScrollIdPipe)); };
SingleMetricByCategoryListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleMetricByCategoryListComponent, selectors: [["ycn-single-metric-by-category-list"]], inputs: { selectedMetricName: "selectedMetricName" }, outputs: { submitMetricHandler: "submitMetricHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 2, consts: [["metricInfoModal", ""], ["collapsableSections", ""], ["nonCollapsableSections", ""], ["dropdownBlock", ""], ["itemBlock", ""], [1, "modal-section"], ["id", "metric-by-category-list-container", 1, "linked-lists"], [1, "linked-list", "user-select-none"], [1, "linked-list-header"], [1, "linked-list-body"], ["class", "linked-list-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "linked-list-body", 4, "ngIf"], [1, "linked-list-item", 3, "ngClass"], [1, "linked-list-item-header", 3, "click"], [3, "textContent"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "linked-list-item-body", "linked-list-sublist"], [1, "linked-list-item", "linked-list-item-dropdown", 3, "ngClass"], [1, "btn", "dropdown-toggler"], [1, "text-gray-10", "linked-list-item-header-wrap"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-body"], ["class", "linked-list-item", 4, "ngFor", "ngForOf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["role", "img", "ycnIcon", "", 3, "name"], [1, "linked-list-item"], ["class", "btn btn-xs btn-circle btn-transparent btn-i", 3, "click", 4, "ngIf"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-i", 3, "click"], ["class", "linked-list-item-header", 4, "ngIf"], [1, "linked-list-item-header"], [1, "linked-list-item-content"], [1, "linked-list-item-content-title"], [1, "text-gray-10"]], template: function SingleMetricByCategoryListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7)(3, "div", 8);
        i0.ɵɵtext(4, "Category");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 9);
        i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_6_Template, 4, 8, "div", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 8);
        i0.ɵɵtext(9, "Metric");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, SingleMetricByCategoryListComponent_div_10_Template, 2, 1, "div", 11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(11, "ycn-metric-info-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.categories);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.categorySelected);
    } }, dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i5.IconDirective, i6.MetricInfoModalComponent, i7.GetCategoryScrollIdPipe, i8.GetCategoryTopScrollIdPipe, i9.GetMetricScrollIdPipe, i10.IsItemSelected, i11.IsSectionItemSelected, i12.IsSubmenuItemSelected], encapsulation: 2, changeDetection: 0 });
